export const initialise = () => {
    if (!document.body.classList.contains('page-home')) return
    const banner = document.querySelector<HTMLElement>('.page-home__hero .banner-pool-widget')
    if (!banner) return
    const video = banner.querySelector<HTMLIFrameElement>('iframe')
    if (!video) return

    const src = video.src
    if (src) {
        const videoIdMatch: RegExpMatchArray | null = src.match(/embed\/([^?]+)/)
        const videoId: string = videoIdMatch ? videoIdMatch[1] : ''
        const separator: string = src.includes('?') ? '&' : '?'
        video.src = `${src}${separator}autoplay=1&mute=1&loop=1&controls=0&disablekb=1&rel=0&playlist=${videoId}`
    }
}